import { connect } from "react-redux";
import { updateUser } from "./redux/actions/authActions";
import RootRouter from "./router/RootRouter";
import { useEffect } from 'react';
 import { getUserDetails, handleOAuthCallback } from './client/firebase/auth';

function App({ setUser }) {
  useEffect(() => {
    async function handleOAuth() {
      if (window.location.pathname === '/auth/callback') {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');

        if (code) {
          await handleOAuthCallback(code);
        } else {
          console.error('No authorization code found in the URL.');
        }
      }
    }
    handleOAuth();
  }, []);

  useEffect(() => {
    async function getUser() {
      const user = await getUserDetails();
      setUser(user);
    }
    getUser();
  }, []);
  

  return (
    <div className='font-inter'>
      <RootRouter />
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  setUser: (user) => dispatch(updateUser(user)),
});

export default connect(null, mapDispatchToProps)(App);
